import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CostRejectionTemplateService } from '../../../services/cost-rejection-template.service';
import { ICostRejectionTemplate } from '../../../interfaces/cost-rejection-template';
import { SelectItem } from 'primeng';
import { FormControl, FormGroup } from '@angular/forms';
import { VmeCommonModule } from '../../../vme-common.module';

@Component({
  selector: 'decline-additional-charge',
  styleUrls: ['./decline-additional-charge.component.scss'],
  templateUrl: './decline-additional-charge.component.html',
  standalone: true,
  imports: [VmeCommonModule],
})
export class DeclineAdditionalChargeComponent implements OnInit {
  rejectionReplyToName: string;
  rejectionFromAddress: string;
  rejectionFromName: any;
  rejectionReplyTo: any;
  rejectionSubject: any;
  rejectionReplyToAddress: any;

  @Input() additionalCharge: any;
  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() confirmDeclineCharge = new EventEmitter<boolean>();

  rejectionReasonId: number = null;
  rejectionText: string;
  rejectionOptions: SelectItem[] = [];
  allReasons: ICostRejectionTemplate[] = [];
  private selectedReason: ICostRejectionTemplate;
  rejectionRecipientAddress: any;
  loading: boolean;
  editForm: FormGroup<any>;
  isSending = false;

  constructor(private costRejectionService: CostRejectionTemplateService) {
    this.editForm = new FormGroup({
      templateWrapperId: new FormControl(),
      additionalChargeId: new FormControl(),
      costRejectionId: new FormControl(),
      rejectionSubject: new FormControl(),
      rejectionText: new FormControl(),
      rejectionRecipientAddress: new FormControl(),
      rejectionFromName: new FormControl(),
      rejectionFromAddress: new FormControl(),
      rejectionReplyToAddress: new FormControl(),
      rejectionReplyToName: new FormControl(),
    });
  }

  ngOnInit() {
    this.getRejectionReasons().then((reasons) => {
      this.allReasons = reasons;
      this.rejectionOptions = reasons.map((item) => {
        return { value: item.id, label: item.headline };
      });
      this.rejectionOptions.unshift({ value: 0, label: 'Select Reason' });
    });
  }

  getRejectionReasons() {
    return this.costRejectionService.search();
  }

  reasonChosen(rejectReasonId: number) {
    if (rejectReasonId > 0) {
      const rejectReason = this.allReasons.find((x) => x.id === rejectReasonId);

      this.loading = true;
      this.costRejectionService
        .getRejectionEmail(this.additionalCharge.id, rejectReasonId)
        .then((x) => {
          this.loading = false;
          this.editForm.patchValue({
            templateWrapperId: rejectReason.templateWrapperId,
            additionalChargeId: this.additionalCharge.id,
            costRejectionId: rejectReasonId,
            rejectionSubject: x.subjectTemplate,
            rejectionText: x.bodyTemplate,
            rejectionRecipientAddress: x.recipientAddressTemplate,
            rejectionFromName: x.senderNameTemplate,
            rejectionFromAddress: x.senderAddressTemplate,
            rejectionReplyToName: x.replyToNameTemplate,
            rejectionReplyToAddress: x.replyToAddressTemplate,
          });
        });
    } else {
      // Clear the form
    }
  }

  sendRejection() {
    this.isSending = true;
    this.costRejectionService.sendRejectionEmail(this.editForm.value).then((x) => {
      this.confirmDeclineCharge.emit(true);
      this.isSending = false;
      this.closeDialog();
    });
  }

  closeDialog() {
    this.visibleChange.emit(false);
  }
}
